import { Box, Button } from '@mui/material'
import { ReactElement } from 'react'
import { DeleteIcon, EditIcon } from 'src/v3/core/icons'

interface EditDeleteButtonsProps {
  moduleName: string
  canSubmit: boolean
  isSubmitting: boolean
  isDisabled: boolean
  handleEdit: () => void
  handleDelete: () => void
}

export default function EditDeleteButtons({
  moduleName,
  isDisabled,
  handleEdit,
  handleDelete,
}: EditDeleteButtonsProps): ReactElement {
  return (
    <Box className="flex flex-wrap gap-4 basis-full md:flex-nowrap md:justify-end md:basis-auto">
      <Button
        fullWidth
        variant="contained"
        size="large"
        startIcon={<EditIcon />}
        onClick={handleEdit}
        aria-label={`Edit ${moduleName}`}
        disabled={isDisabled}
      >
        Edit
      </Button>
      <Button
        fullWidth
        variant="outlined"
        size="large"
        color="error"
        startIcon={<DeleteIcon />}
        onClick={handleDelete}
        aria-label={`Delete ${moduleName}`}
        disabled={isDisabled}
      >
        Delete
      </Button>
    </Box>
  )
}
